export default class SavingsElectricity {
  producto: string;
  p_actual: number;
  p_contratada: number;
  p_potencia_podo: number;
  dias: number;
  energia1: number;
  energia2: number;
  precio_flexi1: number;
  precio_flexi2_1: number;
  precio_flexi2_2: number;
  precio_energia_actual: number;
  precio_energia_actual_1: number;
  precio_energia_actual_2: number;

  constructor(
    producto: string,
    p_actual: number,
    p_contratada: number,
    p_potencia_podo: number,
    dias: number,
    energia1: number,
    energia2: number,
    precio_flexi1: number,
    precio_flexi2_1: number,
    precio_flexi2_2: number,
    precio_energia_actual: number,
    precio_energia_actual_1: number,
    precio_energia_actual_2: number
  ) {
    this.producto = producto;
    this.p_actual = p_actual;
    this.p_contratada = p_contratada;
    this.p_potencia_podo = p_potencia_podo;
    this.dias = dias;
    this.energia1 = energia1;
    this.energia2 = energia2;
    this.precio_flexi1 = precio_flexi1;
    this.precio_flexi2_1 = precio_flexi2_1;
    this.precio_flexi2_2 = precio_flexi2_2;
    this.precio_energia_actual = precio_energia_actual;
    this.precio_energia_actual_1 = precio_energia_actual_1;
    this.precio_energia_actual_2 = precio_energia_actual_2;
  }
}
